import React from 'react';
import { Rate } from 'antd';
import { formatCurrency } from '@/helpers/format';
import { mapRateSearchName } from '@/utils/tools';
import Link from 'next/link';
import usePrefix from '@/hooks/usePrefix';
import { getParkingAtPath, getUrlCodeOrSlug } from '@/utils/newparkingatroutes';
import Image from 'next/image';
import { CDN1, CDN2 } from '@/helpers/api';

function NearbyList({ nearBy, configInfo }: { nearBy: any; configInfo: any; }) {
  const prefix = usePrefix();

  const limitedItems = nearBy?.result?.slice(0, 3);

  return (
    <>
      <ul className="flex flex-col space-y-4">
        {nearBy?.result?.length > 0 &&
          limitedItems?.map((item, index) => {
            const UnbrandedImages = [
              CDN2() + '/staticmyapp/cards-default-image.webp',
              CDN2() + '/staticmyapp/pvd-airport.webp',
              CDN2() + '/staticmyapp/default-image-3.webp',
            ];

            let lastUnbrandedIndex = null;

            const getUnbrandedImage = () => {
              let randomIndex = index % UnbrandedImages.length;
              if (randomIndex === lastUnbrandedIndex) {
                randomIndex = (randomIndex + 1) % UnbrandedImages.length;
              }
              lastUnbrandedIndex = randomIndex;
              return UnbrandedImages[randomIndex];
            };

            let imageUrl = item.facility_is_image_uploaded
              ? `${CDN1}/upload/${configInfo.environment}/${item.facility_id}`
              : getUnbrandedImage();

            const arriveLogo = item.highlights?.find((x) => x.type === 'arrive_logo_url');
            if (arriveLogo) {
              imageUrl = arriveLogo.description;
            }

            return (
              <li key={item.facility_id}>
                <Link
                  href={`${prefix}/${getParkingAtPath(item)}/${getUrlCodeOrSlug(item)}`}
                  className="flex flex-row justify-between border shadow-lg rounded-md p-4 hover:border-2 hover:border-primary"
                >
                  <div className="flex flex-row space-x-4">
                    <Image
                      src={imageUrl}
                      quality={100}
                      className="z-0"
                      width={80}
                      height={80}
                      alt={`Airport: ${item.facility_lot} Background`}
                    />
                    <div>
                      <p className="font-bold">{item.facility_lot}</p>
                      <Rate disabled value={item.facility_review_avg} allowHalf className="text-xs" />
                      <p className="text-xs">({item.num_review} Review)</p>
                    </div>
                  </div>
                  {item.facilityParkingType == 3 || item.facilityParkingType == 4 ? (
                    <div className="flex flex-col justify-center items-center w-full max-w-[8rem]">
                      <div className="font-bold text-sm">
                        {formatCurrency({
                          value: item.facility_solid_selling_price || item.facility_afee,
                          locale: 'en-US',
                          currency: 'USD',
                        })}
                      </div>
                      <div className="font-normal">
                        {item.facilityParkingType == 3 ? 'Sleep and Park' : 'Monthly Park'}
                      </div>
                    </div>
                  ) : (
                    <div className="flex flex-col justify-center items-center w-full max-w-[8rem]">
                      <p className="font-bold text-sm">
                        {formatCurrency({
                          value: item.facility_selling_price,
                          locale: 'en-US',
                          currency: 'USD',
                        })}
                      </p>
                      <p>{mapRateSearchName(item)}</p>
                    </div>
                  )}
                </Link>
              </li>
            );
          })}
      </ul>

    </>
  );
}

export default NearbyList;
